import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { ChapterSummary } from "@domain/lms/course/courseContent";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Title } from "@ui/components/containers/title";
import { Stack } from "@ui/components/layout";
import { gap, mobile } from "@ui/styles/utils";
import { FoldableChapter } from "./foldableChapter";

interface ChaptersSummaryProps extends React.HTMLAttributes<HTMLDivElement> {
	courseId: string;
	chapters: ChapterSummary[];
}
export const ChaptersSummary: React.FC<ChaptersSummaryProps> = ({ courseId, chapters, ...htmlProps }) => {
	if (chapters.length < 1) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<Title>{I18n.t("course.chapters.summary")}</Title>
			<Stack gap={15} align="stretch">
				{chapters.map((chapter, i) => (
					<FoldableChapter key={i} courseId={courseId} chapter={chapter} chapterIndex={i} />
				))}
			</Stack>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	${gap(40)};
	@media ${mobile} {
		${gap(26)};
	}
	padding: 20px;
`;
